export interface IDocumentFactoryRegistrationPostMessage {
  isOk: boolean;
  documentId: number;
  archiveId: number;
  errorMessage?: string;
}

export function instanceOfIDocumentFactoryRegistrationPostMessage(instance: any): instance is IDocumentFactoryRegistrationPostMessage {
  return instance
    && (instance.isOk !== undefined)
    && (instance.archiveId !== undefined)
    && (instance.documentId !== undefined);
}
